import { useTranslation } from "react-i18next";
import "./Hero.css";

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero" id="hero">

      {/* Overlay */}
      <div className="overlay"></div>


      {/* Decorative Elements */}
      <div className="hero-line"></div>


      {/* Content */}
      <div className="hero-content">

        <span className="hero-small-text">
          {t("hero.smallTitle")}
        </span>


        <h1>
          {t("hero.title1")}
          <br />
          <span>
            {t("hero.title2")}
          </span>
        </h1>


        <div className="hero-divider">

          <span></span>

          {/* <i>✦</i> */}

          <span></span>

        </div>


        <p>
          {t("hero.description")}
        </p>


        <div className="hero-buttons">

          <a
            href="#works"
            className="hero-btn primary-btn"
          >
            {t("hero.works")}

            <span>↗</span>
          </a>


          <a
            href="https://www.instagram.com/oumayaeid?igsh=cnlmY29mZjZydm9r"
            className="hero-btn secondary-btn"
          >
            {t("hero.follow")}
          </a>

        </div>

      </div>


      {/* Scroll */}

      <div className="scroll-down">

        <span>
          {t("hero.scroll")}
        </span>

        <div className="scroll-line"></div>

      </div>

    </section>
  );
}

export default Hero;